import { useState } from "react";
import { MapPin, X } from "lucide-react";
import { useWeather } from "@/lib/weather";
import { CitySearch } from "@/components/CitySearch";

const CLOSED = "readoo_meteo_invite_closed";

// Invito una tantum a scegliere la città del meteo: sparisce quando la si sceglie o si chiude.
export function CityInvite() {
  const { city } = useWeather();
  const [closed, setClosed] = useState(() => !!localStorage.getItem(CLOSED));
  const [open, setOpen] = useState(false);
  if (closed || city.manual) return null;
  const close = () => { localStorage.setItem(CLOSED, "1"); setClosed(true); };
  return (
    <div data-testid="city-invite" className="border-b border-hair bg-brandTertiary/40">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center gap-x-3 gap-y-2">
        <MapPin size={15} className="text-brand shrink-0" />
        <p className="text-sm text-onSurface">
          Meteo su {city.name}.{" "}
          <button type="button" data-testid="city-invite-choose" onClick={() => setOpen((v) => !v)} className="font-semibold text-brand hover:underline">
            Scegli la tua città
          </button>
        </p>
        <button type="button" data-testid="city-invite-close" onClick={close} aria-label="Chiudi" className="ml-auto p-1 text-subtle hover:text-onSurface">
          <X size={15} />
        </button>
        {open && <div className="w-full pb-1"><CitySearch /></div>}
      </div>
    </div>
  );
}
